import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import {
	ElectronicProcessPaginationFailure,
	ElectronicProcessPaginationFailureUnit,
	paginationFailureReason
} from '@models/planning/electronic-process-pagination.model'

/**
 * Lista de arquivos que não puderam ter as páginas contadas, cada um com o motivo (spec 002, RF 3 e CA-05): todos de
 * uma vez, não só o primeiro.
 */
@Component({
	selector: 'app-electronic-process-pagination-failures',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
		@if (failure) {
			@if (failure.message) {
				<p class="mb-1">{{ failure.message }}</p>
			}
			@if (units.length) {
				<ul class="mb-0 ps-3 small">
					@for (unit of units; track $index) {
						<li>
							<span class="fw-600">{{ unit.label || 'Arquivo ' + unit.seq }}</span>
							<span class="text-muted">· {{ reason(unit) }}</span>
						</li>
					}
				</ul>
			}
		}
	`,
	standalone: false
})
export class ElectronicProcessPaginationFailuresComponent {
	@Input() failure: ElectronicProcessPaginationFailure | null = null

	get units(): ElectronicProcessPaginationFailureUnit[] {
		return this.failure?.units ?? []
	}

	reason(unit: ElectronicProcessPaginationFailureUnit): string {
		return paginationFailureReason(unit)
	}
}
